export * from './TextEllipsis';
try {
    // @ts-ignore
    TextEllipsis.displayName = "TextEllipsis";
    // @ts-ignore
    TextEllipsis.__docgenInfo = { "description": "", "displayName": "TextEllipsis", "props": { "size": { "defaultValue": null, "description": "", "name": "size", "required": true, "type": { "name": "number" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/TextEllipsis/index.ts#TextEllipsis"] = { docgenInfo: TextEllipsis.__docgenInfo, name: "TextEllipsis", path: "src/components/TextEllipsis/index.ts#TextEllipsis" };
}
catch (__react_docgen_typescript_loader_error) { }